import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { client } from '../amplify-client';
import { EisdielenKarte, type KartenPunkt } from '../components/EisdielenKarte';
import { GuennieIcon } from '../components/GuennieIcon';
import { farbeFuerGuennies } from '../components/GuennieRating';
import { SpaghettiDivider } from '../components/SpaghettiDivider';

const STUFEN: Array<[number, string]> = [
  [1, 'durchgefallen'],
  [2, 'geht besser'],
  [3, 'solide'],
  [4, 'hervorragend'],
  [5, 'Referenzklasse'],
];

/** „Karte" (Bauphase 6) — alle getesteten Eisdielen auf einen Blick, per Marker eingefärbt nach Ø-Gesamtbewertung. */
export function KarteEisdielen() {
  const navigate = useNavigate();
  const [punkte, setPunkte] = useState<KartenPunkt[]>([]);
  const [laedt, setLaedt] = useState(true);
  const [fehler, setFehler] = useState<string | null>(null);

  useEffect(() => {
    client.queries
      .karteEisdielen()
      .then(({ data, errors }) => {
        if (errors?.length) throw new Error(errors[0].message);
        setPunkte((data ?? []).filter(Boolean) as KartenPunkt[]);
      })
      .catch((e) => setFehler(String(e?.message ?? e)))
      .finally(() => setLaedt(false));
  }, []);

  return (
    <div className="container">
      <p className="label">Der Führer</p>
      <h1>Karte</h1>
      <SpaghettiDivider />

      {laedt ? <p className="label">Lädt …</p> : null}
      {fehler ? (
        <p className="hinweis" style={{ borderColor: 'var(--erdbeere)' }}>
          Konnte die Karte nicht laden: {fehler}
        </p>
      ) : null}
      {!laedt && !fehler && punkte.length === 0 ? (
        <p style={{ color: 'var(--espresso-70)' }}>Noch keine getestete Eisdiele mit veröffentlichter Verkostung.</p>
      ) : null}

      {!laedt && punkte.length > 0 ? (
        <>
          <EisdielenKarte punkte={punkte} hoehe={560} onAuswahl={(id) => navigate(`/app/eisdielen/${id}`)} />
          <div style={{ display: 'flex', gap: '1.1rem', flexWrap: 'wrap', marginTop: '0.85rem' }}>
            {STUFEN.map(([n, label]) => (
              <span
                key={n}
                style={{ display: 'inline-flex', alignItems: 'center', gap: '0.35rem', fontSize: '0.8rem', color: 'var(--espresso-70)' }}
              >
                <GuennieIcon gefuellt groesse={16} farbe={farbeFuerGuennies(n)} />
                {label}
              </span>
            ))}
          </div>
        </>
      ) : null}
    </div>
  );
}
